export const GET_ALL_DEALERS = 'Dealers/GET_ALL_DEALERS';
export const UPDATE_PAGE_NUMBER = 'Dealers/UPDATE_PAGE_NUMBER';
export const RESET_LOADING_FLAG = 'Dealers/RESET_LOADING_FLAG';
export const SEARCH_TERM_ADDED = 'Dealers/SEARCH_TERM_ADDED';